import { render, staticRenderFns } from "./index_use_paye.vue?vue&type=template&id=40a06978&"
import script from "./index_use_paye.vue?vue&type=script&lang=js&"
export * from "./index_use_paye.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports